/* ============================================================================
   Toggle.tsx — checkbox custom rectangle 14x14, fill ink quand checked.
   ============================================================================ */

interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  disabled?: boolean;
}

export function Toggle({ label, checked, onChange, id, disabled = false }: ToggleProps) {
  const inputId = id ?? `toggle-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <div className="controls-row controls-row--toggle">
      <label className="controls-label controls-label--clickable" htmlFor={inputId}>
        <span
          className={`controls-toggle${checked ? ' controls-toggle--on' : ''}`}
          aria-hidden="true"
        />
        <span>{label}</span>
      </label>
      <input
        id={inputId}
        type="checkbox"
        className="controls-toggle__input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        aria-label={label}
      />
    </div>
  );
}
